module.exports = __webpack_public_path__ + "img/4.f4a0794f.png";